import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { PageHero, Container } from "../components/Section";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function DonateSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [txn, setTxn] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/donations/status/${sessionId}`);
        setTxn(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch {
        // ignore
      }
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="donate-success-page">
      <PageHero
        overline="Thank You"
        title={status === "paid" ? <>Your gift is <em className="text-gold-light italic font-light">received</em>.</> : <>Processing your <em className="text-gold-light italic font-light">gift</em>…</>}
        kicker={status === "paid" ? "Heaven is rejoicing. Your generosity fuels Kingdom work in Hampton and beyond." : "Just a moment — we're confirming your donation."}
        image="/images/branding/ways-to-give.jpg"
      />
      <Container className="pb-32">
        <div className="glass p-12 max-w-2xl">
          {status === "polling" && <div className="flex items-center gap-3 text-white/70"><Loader2 className="h-5 w-5 animate-spin" /> Confirming payment…</div>}
          {status === "paid" && (
            <div>
              <CheckCircle2 className="h-12 w-12 text-gold mb-4" />
              <h3 className="font-serif text-3xl font-black mb-3">Payment Successful</h3>
              {txn && (
                <div className="text-white/75 space-y-2 mt-4">
                  <div>Amount: <span className="text-gold font-serif text-xl">${txn.amount?.toFixed(2)} USD</span></div>
                  <div>Fund: {txn.fund}</div>
                  <div className="text-xs text-white/45 mt-4">A receipt has been emailed (if Resend is configured).</div>
                </div>
              )}
              <Link to="/" className="btn-ghost inline-block mt-8 px-6 py-2.5 rounded-full text-xs uppercase tracking-widest">Return Home</Link>
            </div>
          )}
          {(status === "expired" || status === "error" || status === "timeout") && (
            <div>
              <XCircle className="h-12 w-12 text-destructive mb-4" />
              <h3 className="font-serif text-2xl font-black mb-3">We couldn't confirm your gift</h3>
              <p className="text-white/65">If you completed payment, please contact us. Otherwise <Link to="/donate" className="text-gold underline">try again</Link>.</p>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}
